export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1751_.f0ba6191.jpg";